<template>
    <div>
        <!-- Begin:PageContent -->
        <section id="content">
            <div class="container">
                <div class="row">
                    <!-- Begin:PagePrivacy -->
                    <div id="main" class="col-md-9">
                        <div class="container shortcode travel-ideas">
                            <h1 class="idea-title">
                                <span class="index">
                                    <i class="soap-icon-star circle"></i>
                                </span>
                                {{ titleinfo[getCurrentLocale] }}
                            </h1>
                        </div>
                        <br />
                        <br />

                        <div class="booking-information sdr-box">
                            <h4 v-html="servicesonboard_h4_1[getCurrentLocale]"></h4>
                            <p v-html="servicesonboard_p_1[getCurrentLocale]"></p>
                        </div>
                    </div>
                    <!-- End:PagePrivacy -->

                    <!-- Begin:Content-SideBar -->
                    <div class="sidebar col-md-3">
                        <sdr-aboutsundair-box></sdr-aboutsundair-box>
                        <sdr-contact-box></sdr-contact-box>
                    </div>
                    <!-- END:Content-SideBar -->
                </div>
            </div>
        </section>
        <!-- End:PageContent -->

        <!-- Begin:PromoBox -->
        <sdr-promobox></sdr-promobox>
        <!-- End:PromoBox -->
    </div>
</template>

<script>
    import AboutSundairBox from '../../shared/sidebar/AboutSundairBox.vue'; // Sidebar (right)
    import ContactBox from '../../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import PromoBox from '../../booking/pagecontent/PromoBox.vue';

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-aboutsundair-box': AboutSundairBox,
            'sdr-contact-box': ContactBox,
            'sdr-promobox': PromoBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                titleinfo: {
                    en: 'Important information:',
                    de: 'Wichtige Hinweise:',
                },
                // >>> --------------------------
                servicesonboard_h4_1: {
                    en: 'Important infomation for seat and special reservations',
                    de: 'Wichtige Hinweise für Sitzplatz- und Servicereservierung',
                },
                servicesonboard_p_1: {
                    en: '<strong>1.</strong> online seat reservations are only available for firm bookings made 6 months or more up to 2 days prior to departure.<br /><br /><strong>2.</strong> Nouvel does not guarantee your reservations.<br />In the rare case of a carrier change, the use of a different aircraft type or other important reasons, Nouvelair check-in staff and cabin crew may assign other seats to passengers.<br /><br /><strong>3.</strong> there will be no refund of reservations/registrations for which a fee has been charged.',
                    de: '<strong>1.</strong> Online-Sitzplatzreservierungen sind nur für Festbuchungen ab 6 Monaten bis 2 Tage vor Abflug möglich.<br /><br /><strong>2.</strong> Nouvel übernimmt keine Garantie für Ihre Reservierungen.<br />Im seltenen Falle eines Carrier - Wechsels, dem Einsatzes eines anderen Flugzeugmusters oder anderer wichtiger Gründe kann das Check-In Personal und das Kabinenpersonal der Nouvelair den Passagieren andere Sitzplätze zuweisen.<br /><br /><strong>3.</strong> Es erfolgt keine Erstattung von kostenpflichtigen Reservierungen/Anmeldungen.',
                },
                // getCurrentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
a[target='_blank']:after {
    font-family: 'FontAwesome';
    content: ' \f08e';
}

/* >>>  iPAD -------------------------------------------------------------*/
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    h1 {
        font-size: 1.6em;
    }
    .booking-information {
        padding: 20px 30px 30px;
        padding-top: 20px;
        padding-right: 15px;
        padding-bottom: 30px;
        padding-left: 15px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/infos/serviceonboard/Home.vue